import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useAccessGroupApi = () => {
    const { getDataAsync } = useApi();

    const getAccessGroupApiCall = useCallback(
        async (groupId) => {
            const response = await getDataAsync("group", {
                urlParams: [{ name: "$groupId", value: groupId }],
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;
        },
        [getDataAsync]
    );

    return useMemo(() => {
        const useAccessGroup = (groupId) =>
            useQuery(["accessGroup", groupId], () =>
                getAccessGroupApiCall(groupId)
            );

        return {
            useAccessGroup,
        };
    }, [getAccessGroupApiCall]);
};

export default useAccessGroupApi;
